import React, { useEffect } from 'react';

const DriverLeadFormThankYou = () => {
  useEffect(() => {
    // Fire GA4 conversion event for form submission
    if (window.gtag) {
      window.gtag('event', 'generate_lead', {
        event_category: 'Driver Lead Form',
        event_label: 'Form Submitted',
        value: 1
      });
    }

    // Push to dataLayer for additional tracking
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'driver_lead_form_submitted',
        formName: 'Driver Lead Form',
        submissionTime: new Date().toISOString()
      });
    }
  }, []);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center">
        {/* Nura Logo */}
        <img 
          src="/nura-black.png" 
          alt="Nura" 
          className="h-12 mx-auto mb-8"
        />

        {/* Thank You Message */}
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          Thank You! 🎉
        </h1>
        <h2 className="text-2xl font-bold text-gray-900 mb-6">
          நன்றி! 🎉
        </h2>

        <p className="text-lg text-gray-600 mb-2">
          Your application has been submitted successfully.
        </p>
        <p className="text-lg text-gray-600 mb-6">
          உங்கள் விண்ணப்பம் வெற்றிகரமாக சமர்ப்பிக்கப்பட்டது.
        </p>

        <p className="text-lg text-gray-600 mb-2">
          Our team will contact you shortly.
        </p>
        <p className="text-lg text-gray-600">
          எங்கள் குழு விரைவில் உங்களைத் தொடர்புகொள்ளும்.
        </p>
      </div>
    </div>
  );
};

export default DriverLeadFormThankYou;
